export default __webpack_public_path__ + "static/media/sendMoney.282b1053.svg";